import { determineComponentExports, } from './component';
export class Behavior {
    /** @internal */
    constructor(inner, parents, definitionFilter, chainingFilter, componentExport) {
        this._$ = inner;
        this._$chainingFilter = chainingFilter;
        this._$export = determineComponentExports(parents, componentExport);
        // processing definition filter
        if (definitionFilter !== undefined) {
            const definitionFilterArgs = parents.map((p) => { var _a; return (_a = p._$boundDefinitionFilter) !== null && _a !== void 0 ? _a : null; });
            this._$boundDefinitionFilter = (childDef) => {
                definitionFilter(childDef, definitionFilterArgs);
            };
        }
    }
}
export class ComponentType {
    /** @internal */
    constructor(inner) {
        // this field is designed for type identification in some external modules, such as glass-easel-analyzer
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this._$fieldTypes = undefined;
        this._$ = inner;
    }
}
export class TraitBehavior {
    constructor(inner) {
        this._$ = inner;
    }
}
//# sourceMappingURL=behavior.js.map